import moment from 'moment';



const disableDateBeforeYesterday = (current) => {
  return current && current < moment().subtract(1, 'day').startOf('day');
};

export default disableDateBeforeYesterday;
